import React, { useState, useEffect } from "react";
import './QuiSommesNous.css';
import Photovic from './Image/Image-Victor.jpg';
import PhotoEnv from './Image/IMG-20260323-WA0000.jpg'; // REMPLACE CECI par ta 2ème image (ex: ./Image/Nature.jpg)
import Footer from './Footer';
import Loader from "./Loader";
import { updateParagraph1, updateParagraph2, listenQuiSommesNous } from './firestore';
import { useAuth } from "./AuthContext";

const adminEmails = ["youenhamon@gmail.com", "victorleoleblanc@gmail.com", "nicolas.tannevet@orange.fr"];

const QuiSommesNous = ({ hidden, toggleFooter }) => {
    const [paragraphs, setParagraphs] = useState({
        id: '',
        paragraph1: '',
        paragraph2: ''
    });
    const [isEditing1, setIsEditing1] = useState(false);
    const [isEditing2, setIsEditing2] = useState(false);
    const [newParagraph1, setNewParagraph1] = useState("");
    const [newParagraph2, setNewParagraph2] = useState("");
    const { user } = useAuth();
    const isAdmin = user && adminEmails.includes(user.email);
    const [showHelp, setShowHelp] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => { 
        const unsubscribe = listenQuiSommesNous((data) => {
            setParagraphs(data);
            setNewParagraph1(data.paragraph1 || "");
            setNewParagraph2(data.paragraph2 || "");
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const handleUpdateParagraph1 = async (e) => {
        e.preventDefault();
        if (paragraphs.id) {
            try {
                await updateParagraph1(paragraphs.id, newParagraph1);
                setIsEditing1(false);
            } catch (error) {
                console.error('Erreur update 1:', error);
            }
        }
    };

    const handleUpdateParagraph2 = async (e) => {
        e.preventDefault();
        if (paragraphs.id) {
            try {
                await updateParagraph2(paragraphs.id, newParagraph2);
                setIsEditing2(false);
            } catch (error) {
                console.error('Erreur update 2:', error);
            }
        }
    };

    return (
        <>
            <div hidden={hidden}>
                <h1>Qui sommes-nous</h1>
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        {/* BLOC 1 : Texte Gauche / Image Droite */}
                        <div className="content">
                            <div className="text-container">
                                {!isEditing1 ? (
                                    <>
                                        <p style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: paragraphs.paragraph1 }}></p>
                                        {isAdmin && (
                                            <button className="edit-button" onClick={() => setIsEditing1(true)}>Modifier le texte</button>
                                        )}
                                    </>
                                ) : (
                                    <form className="test-form" onSubmit={handleUpdateParagraph1}>
                                        <textarea
                                            className="expanded-textarea"
                                            value={newParagraph1}
                                            onChange={(e) => setNewParagraph1(e.target.value)}
                                            placeholder="Texte paragraphe 1"
                                        />
                                        <div className="button-container">
                                            <button className="edit-button" type="submit">Mettre à jour</button>
                                            <button className="edit-button" type="button" onClick={() => setShowHelp(true)}>Aide</button>
                                            <button className="edit-button" type="button" onClick={() => setIsEditing1(false)}>Annuler</button>
                                        </div>
                                    </form>
                                )}
                            </div>
                            <div className="image-container">
                                <img src={Photovic} alt="Victor" className="Photo" />
                            </div>
                        </div>

                        {/* BLOC 2 : Image Gauche / Texte Droite */}
                        <div className="content-2">
                            {/* J'ai ajouté l'image ICI pour qu'elle soit à gauche */}
                            <div className="image-container">
                                <img src={PhotoEnv} alt="Environnement" className="Photo" />
                            </div>

                            <div className="texte-environnement">
                                {!isEditing2 ? (
                                    <>
                                        <p style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: paragraphs.paragraph2 }}></p>
                                        {isAdmin && (
                                            <button className="edit-button" onClick={() => setIsEditing2(true)}>Modifier le texte</button>
                                        )}
                                    </>
                                ) : (
                                    <form className="edit-form" onSubmit={handleUpdateParagraph2}>
                                        <textarea
                                            className="expanded-textarea"
                                            value={newParagraph2}
                                            onChange={(e) => setNewParagraph2(e.target.value)}
                                            placeholder="Texte paragraphe 2"
                                        />
                                        <div className="button-container">
                                            <button className="edit-button" type="submit">Mettre à jour</button>
                                            <button className="edit-button" type="button" onClick={() => setShowHelp(true)}>Aide</button>
                                            <button className="edit-button" type="button" onClick={() => setIsEditing2(false)}>Annuler</button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                        <Footer setShowMentionsLegales={toggleFooter} isRelative={true} />
                    </>
                )}
            </div>
            
            {/* MODAL D'AIDE (Inchangé) */}
            {showHelp && (
                <div className="help-overlay">
                    <div className="help-content">
                        <h2>Aide</h2>
                        <p>Pour mettre un texte en gras : <code>&lt;b&gt;texte&lt;/b&gt;</code><br/>
                           Pour mettre un texte en italique : <code>&lt;i&gt;texte&lt;/i&gt;</code><br/>
                           Pour souligner du texte : <code>&lt;u&gt;texte&lt;/u&gt;</code><br/><br/>
                           Pour modifier la taille : <code>&lt;span style=&quot;font-size: 16px;&quot;&gt;texte&lt;/span&gt;</code><br/><br/>
                           Pour la couleur : <code>&lt;span style=&quot;color: blue;&quot;&gt;texte&lt;/span&gt;</code><br/>
                           Vert foncé Arbre : #2A4C21<br/>
                           Vert clair Feuilles : #83BC2A<br/>
                           Orange Citrouille : #F07D0C<br/>
                        </p>
                        <div className="button-container">
                            <button onClick={() => setShowHelp(false)}>Fermer</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default QuiSommesNous;